import _extends from '@babel/runtime/helpers/extends';
import React__default, { useState } from 'react';
import styled, { css } from 'styled-components';
import { I as Input } from '../Input/Input-DPza2AXJ.js';
import { P as PillBox } from './PillBox-itGX1tUJ.js';
import { g as getTranslationComponent } from '../i18n/ListBuilderInputTranslation/static-SL0AuvKM.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { I as IntlProvider } from '../LocalModules/storm-ui-intl/dist/esm/IntlProvider-DmRs8GLp-yq9BpgTU.js';
import { u as useIntl } from '../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-BLE3wELi-CV9fXVbx.js';
import { B as Button } from '../Button/Button-C2QYbC6E.js';

const ListBuilderWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40013943__sc-qxh3rc-0"
})(["height:100%;width:100%;display:flex;flex-direction:column;background-color:", ";"], ({
  theme
}) => theme.surface.default);
const ListBuilderBaseWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40013943__sc-qxh3rc-1"
})(["display:flex;flex:0 0 auto;flex-direction:column;border:", ";border-radius:", ";padding-block-start:", ";padding-block-end:", ";padding-inline-start:", ";padding-inline-end:", ";", ""], ({
  theme
}) => theme.border.medium.default, ({
  theme,
  $hasItems
}) => $hasItems ? `${theme.border.radius.small} ${theme.border.radius.small} 0 0` : theme.border.radius.small, ({
  theme
}) => theme.spacing.xsmall.default, ({
  theme,
  $hasMessage
}) => $hasMessage ? theme.spacing.xxxsmall.default : theme.spacing.xsmall.default, ({
  theme
}) => theme.spacing.xsmall.default, ({
  theme
}) => theme.spacing.xsmall.default, isMobile(css(["padding-block-start:", ";padding-block-end:", ";padding-inline-start:", ";padding-inline-end:", ";"], ({
  theme
}) => theme.spacing.xsmall.mobile, ({
  theme,
  $hasMessage
}) => $hasMessage ? theme.spacing.xxxsmall.mobile : theme.spacing.xsmall.mobile, ({
  theme
}) => theme.spacing.xsmall.mobile, ({
  theme
}) => theme.spacing.xsmall.mobile)));
const AddButton = /*#__PURE__*/styled(Button).withConfig({
  componentId: "sc-storm-ui-40013943__sc-qxh3rc-2"
})(["align-items:center;", ""], isMobile(css(["height:", ";"], ({
  theme
}) => `calc(${theme.controls.paddingInline.large.mobile} + ${theme.controls.paddingBlock.base.mobile} + ${theme.spacing.base.mobile} + 2px)`)));
const ListBuilderInputWrapper = /*#__PURE__*/styled('form').withConfig({
  componentId: "sc-storm-ui-40013943__sc-qxh3rc-3"
})(["display:flex;flex:1 1 auto;align-items:flex-start;justify-content:space-between;gap:", ";", ""], ({
  theme
}) => theme.spacing.xsmall.default, isMobile(css(["gap:", ";"], ({
  theme
}) => theme.spacing.xsmall.mobile)));
const ListBuilderComponent = ({
  id,
  addText,
  items = [],
  onAdd,
  onRemovePill,
  onRemoveAll,
  removeAllLabel,
  disableAdd,
  onChange,
  disabled,
  message,
  ...rest
}) => {
  const [inputVal, setInputVal] = useState('');
  const handleInputChange = event => {
    var _event$target;
    setInputVal((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value);
    onChange === null || onChange === void 0 || onChange(event);
  };
  const handleOnAdd = event => {
    onAdd === null || onAdd === void 0 || onAdd(event, inputVal);
    setInputVal('');
  };
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React__default.createElement(ListBuilderWrapper, {
    id: id
  }, /*#__PURE__*/React__default.createElement(ListBuilderBaseWrapper, {
    $hasMessage: !!message,
    $hasItems: (items === null || items === void 0 ? void 0 : items.length) > 0
  }, /*#__PURE__*/React__default.createElement(ListBuilderInputWrapper, {
    onSubmit: event => event.preventDefault()
  }, /*#__PURE__*/React__default.createElement(Input, _extends({}, rest, {
    fullWidth: true,
    id: `${id}-input`,
    value: inputVal,
    onChange: handleInputChange,
    disabled: disabled,
    message: message
  })), /*#__PURE__*/React__default.createElement(AddButton, {
    type: "submit",
    onClick: handleOnAdd,
    disabled: disabled || disableAdd,
    tabIndex: 0
  }, addText !== null && addText !== void 0 ? addText : formatMessage({
    id: 'button_add'
  })))), items && items.length ? /*#__PURE__*/React__default.createElement(PillBox, {
    pills: items,
    onRemovePill: onRemovePill,
    onRemoveAll: onRemoveAll,
    removeAllLabel: removeAllLabel !== null && removeAllLabel !== void 0 ? removeAllLabel : formatMessage({
      id: 'button_remove_all'
    })
  }) : null);
};
const ListBuilderInput = ({
  locale = 'en-US',
  ...rest
}) => {
  const translations = getTranslationComponent(locale);
  return /*#__PURE__*/React__default.createElement(IntlProvider, {
    translations: translations
  }, /*#__PURE__*/React__default.createElement(ListBuilderComponent, rest));
};

export { ListBuilderInput as L };
//# sourceMappingURL=ListBuilderInput-CiBe8F5K.js.map
